import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  @Input() title: string;
}
